import { csx } from '@vtex/admin-ui'

export const sellerFilterHeader = csx({
  padding: '$space-4 $space-5 $space-1',
  maxHeight: '15rem',
  input: {
    minWidth: 'auto',
  },
})
